var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgM1V(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m39.124 2.5h-25.124a4 4 0 0 0 -4 4v50a4 4 0 0 0 4 4h36a4 4 0 0 0 4-4v-39.124z",
    fill: "#ededed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m53 43.393h-22.914l-2.4-2.745a2 2 0 0 0 -1.505-.684h-15.181a2 2 0 0 0 -2 2v14.536a5.006 5.006 0 0 0 5 5h36a5.006 5.006 0 0 0 5-5v-11.107a2 2 0 0 0 -2-2z",
    fill: "#36a9e1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m37.729 22.25-9.016-5.2a1 1 0 0 0 -1.5.866v10.406a1 1 0 0 0 1.5.866l9.016-5.206a1 1 0 0 0 0-1.732z",
    fill: "#c6c6c6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m53.707 17.083-14.29-14.29a1 1 0 0 0 -1.707.707v7.4a13.538 13.538 0 1 0 7.066 7.889h8.224a1 1 0 0 0 .707-1.707zm-10.207 6.033a11.534 11.534 0 1 1 -5.79-9.968v1.642a4 4 0 0 0 4 4h.938a11.414 11.414 0 0 1 .852 4.326z",
    fill: "#c6c6c6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.514 51.142-1.74 6.084h-1.452l-1.716-6.072v6.072h-1.706v-8.926h2.556l1.584 5.736 1.6-5.736h2.58v8.928h-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.742 55.738h1.344v-5.712h-1.548v-1.272a5.712 5.712 0 0 0 1.044-.126 1.9 1.9 0 0 0 .924-.474h1.38v7.584h1.356v1.488h-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.582 57.226-2.364-8.926h1.908l1.44 6.012 1.512-6.012h1.922l-2.376 8.928z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM1V);
export default __webpack_public_path__ + "static/media/m1v.7146e91e300d1d7e7e264e80b5806d49.svg";
export { ForwardRef as ReactComponent };